/**
 * @generated SignedSource<<72506ae8440435e02d7f3c56abf88feb>>
 * @relayHash 37d93a84b6e6288eab04437f1692cb28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b68508a27ab628b521cd513005cdad2a9785f41028da93157f24132b2909ad09

import type { ConcreteRequest } from 'relay-runtime';
export type fetchComponentsQuery$variables = {
  cloudId: string;
  componentIds: ReadonlyArray<string>;
  first: number;
  idOrKey: string;
};
export type fetchComponentsQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly components: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly componentId: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type fetchComponentsQuery = {
  response: fetchComponentsQuery$data;
  variables: fetchComponentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "idOrKey"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "idOrKey"
  }
],
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "componentIds"
      },
      {
        "kind": "Literal",
        "name": "operation",
        "value": "ALLOW"
      }
    ],
    "kind": "ObjectValue",
    "name": "filterById"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "componentId"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "fetchComponentsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraComponentConnection",
            "kind": "LinkedField",
            "name": "components",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraComponentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraComponent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchComponentsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraComponentConnection",
            "kind": "LinkedField",
            "name": "components",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraComponentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraComponent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "b68508a27ab628b521cd513005cdad2a9785f41028da93157f24132b2909ad09",
    "metadata": {},
    "name": "fetchComponentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6c026a99ef4cd36167652e2f64e1e401";

export default node;
